import React from 'react';
import { Container, Typography, Paper, Grid, Box } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';

const EducationLevelsPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        <SchoolIcon sx={{ mr: 1 }} />
        Níveis de Ensino
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Educação Infantil
            </Typography>
            <Typography variant="body1">
              A Educação Infantil é uma etapa fundamental para o desenvolvimento das crianças, onde trabalhamos o desenvolvimento emocional, social e cognitivo por meio de atividades lúdicas e pedagógicas.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Ensino Fundamental
            </Typography>
            <Typography variant="body1">
              O Ensino Fundamental é dividido em anos iniciais e finais, com foco no desenvolvimento das competências básicas de leitura, escrita, matemática e ciências. Utilizamos métodos modernos e recursos didáticos para proporcionar um aprendizado significativo.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Ensino Médio
            </Typography>
            <Typography variant="body1">
              O Ensino Médio prepara os alunos para o ingresso no ensino superior e para o mercado de trabalho, com uma abordagem que integra teoria e prática, promovendo o pensamento crítico e a formação cidadã.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EducationLevelsPage;
